const getPageText = (page) => String(page?.text || page?.content || '').trim();

const getSourcePageNumber = (page, index) => Number(page?.pageNumber) || index + 1;

const splitSentences = (text) => text
  .split(/(?<=[.!?])\s+/)
  .map((sentence) => sentence.trim())
  .filter(Boolean);

const splitWords = (text, maxWords) => {
  const words = text.split(/\s+/).filter(Boolean);
  const chunks = [];
  for (let index = 0; index < words.length; index += maxWords) {
    chunks.push(words.slice(index, index + maxWords).join(' '));
  }
  return chunks;
};

const packSentences = (sentences, maxWords) => {
  const chunks = [];
  let current = [];
  let currentWordCount = 0;

  sentences.forEach((sentence) => {
    const sentenceWords = sentence.split(/\s+/).filter(Boolean);
    if (sentenceWords.length > maxWords) {
      if (current.length) {
        chunks.push(current.join(' '));
        current = [];
        currentWordCount = 0;
      }
      chunks.push(...splitWords(sentence, maxWords));
      return;
    }

    if (current.length && currentWordCount + sentenceWords.length > maxWords) {
      chunks.push(current.join(' '));
      current = [];
      currentWordCount = 0;
    }
    current.push(sentence);
    currentWordCount += sentenceWords.length;
  });

  if (current.length) chunks.push(current.join(' '));
  return chunks;
};

/**
 * Turns source story pages into stable, readable display pages. A continuation
 * keeps the source identity for audio caching but intentionally does not repeat
 * the source illustration.
 */
export const deriveDisplayPages = (pages = [], readingMode = 'picture') => {
  const maxWords = readingMode === 'storybook' ? 28 : 32;
  return pages.flatMap((page, sourceIndex) => {
    const text = getPageText(page) || 'Your story is still taking shape.';
    const chunks = packSentences(splitSentences(text), maxWords);
    const sourcePageNumber = getSourcePageNumber(page, sourceIndex);
    return chunks.map((chunk, chunkIndex) => ({
      ...page,
      text: chunk,
      content: chunk,
      imageUrl: chunkIndex === 0 ? page?.imageUrl : null,
      image_url: chunkIndex === 0 ? page?.image_url : null,
      image: chunkIndex === 0 ? page?.image : null,
      pageNumber: sourcePageNumber,
      sourcePageNumber,
      chunkIndex,
      displayPageId: `p${sourcePageNumber}-c${chunkIndex + 1}`,
      audioKey: chunks.length === 1 ? String(sourcePageNumber) : `p${sourcePageNumber}-c${chunkIndex + 1}`,
    }));
  });
};

export const getDisplayPageText = getPageText;
